import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PurchaseService } from '@service/purchase/purchase.service';
import { CustomToastrService } from '@service/toastr/custom-toastr.service';
import { AuthService } from '@service/auth.service';
import { Subject } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { DataDisplayDialogComponent } from '../../../shared/dialog/data-display-dialog/data-display-dialog.component';

@Component({
  selector: 'app-purchase-by-adforce',
  templateUrl: './purchase-by-adforce.component.html',
  styleUrls: ['./purchase-by-adforce.component.scss']
})
export class PurchaseByAdforceComponent implements OnInit, OnDestroy {
  private componentDestroyed$: Subject<any> = new Subject();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private purchaseService: PurchaseService,
    private customToastrService: CustomToastrService,
    private authService: AuthService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.ngInitOveride();
    if (window.location.search.includes('hypothese_id=')) {
      const queryString = window.location.search.substring(1);
      const encodedData = btoa(queryString);
      this.router.navigate([`create/purchaseByAdforce/${encodedData}`]).then(() => {
        window.location.reload();
      });
      return ;
    }
  }

  ngInitOveride()
  {
    if (this.authService.isLoggedIn()) {
      this.initComponent();
    } else {
      this.authService.eventLogged$
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe((isLoggedIn) => {
          if (isLoggedIn) {
            this.initComponent();
          }
        });
    }
  }
  
  initComponent() {
    this.route.params.pipe(take(1)).subscribe(params => {
      let data = params['data'];

      if (data) {
        try {
          data = atob(data);
        } catch (e) {
          console.warn('Data provided is not base64 encoded or invalid');
        }
      } else {
        const queryParams = this.route.snapshot.queryParams;
        if (queryParams && Object.keys(queryParams).length > 0) {
           
           const queryString = Object.keys(queryParams).map(key => key + '=' + queryParams[key]).join('&');
           data = queryString;
        }
      }

      const dataParam = {};
      data.split("&").forEach(pair => {
      const [key, value] = pair.split("=");
      dataParam[key] = decodeURIComponent(value);
    });
      if (dataParam) {
        this.createPurchase(dataParam);
      } else {
        this.handleError('Données manquantes');
      }
    });
  }

  createPurchase(data) {
    this.purchaseService.createPurchaseByAdforce(data)
      .subscribe(
        (purchase) => {
          if (purchase && purchase.id) {
            this.customToastrService.displayToastr('SUCCESS', purchase.message);
            this.router.navigate(['/purchases/edit/', purchase.id]);
          } else if (purchase && purchase.detail) {
            try {
              const details = JSON.parse(purchase.detail);
              if (Array.isArray(details) && details.length > 0) {
                this.dialog.open(DataDisplayDialogComponent, {
                  data: details,
                  width: '600px'
                });
              }
            } catch (e) {
              this.customToastrService.displayToastr('ERROR', 'Merci de s\'authentifier ou actualiser votre page.');
            }
          } else {
            this.customToastrService.displayToastr('ERROR', 'Réponse invalide de l\'API');
            this.dialog.open(DataDisplayDialogComponent, {
              data: data,
              width: '600px'
            });
          }
        },
        (error) => {
          this.customToastrService.displayToastr('ERROR', 'Merci de s\'authentifier ou actualiser votre page.');
        }
      );
  }

  handleError(message: string) {
    this.customToastrService.displayToastr('ERROR', message);
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.componentDestroyed$.unsubscribe();
  }
}
